export default {
  feedback: {
    token_required: 'Bitte klicke das Kontrollkästchen, um zu bestätigen, dass du ein Mensch bist',
    frequent_requests:
      'Bitte prüfen deine SMS. Wir haben den Code bereits an die angegeben Nummer per SMS gesendet. Wenn nicht prüfe bitte die Telefonnummer oder versuche es bitte in 10 Minuten erneut.',
  },
};
